import { observable } from "mobx";
import { Type } from "class-transformer";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundChargeDetailResponse from "./refundChargeDetailResponse";
import RefundFeeResponse from "./refundFeeResponse";
import RefundOriginalPayGatePaymentDetailResponse from "./refundOriginalPayGatePaymentDetailResponse";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class PayGateRefundDetailResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeDetailResponse)
  charge?: RefundChargeDetailResponse;

  @observable
  @Type(() => RefundFeeResponse)
  fees!: RefundFeeResponse[];

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  officialRecordId?: string;

  @observable
  @Type(() => RefundOriginalPayGatePaymentDetailResponse)
  originalPayment?: RefundOriginalPayGatePaymentDetailResponse;

  @observable
  payGatePaymentIdent?: string;
}
